import React, { MouseEvent } from 'react';
import cn from 'classnames';
import { formatDistanceToNowStrict } from 'date-fns';
import DOMPurify from 'dompurify';

import { AdaptiveSingleLineText, Icons } from '@components/common';

import styles from './NotificationItem.module.scss';

interface INotificationItemProps {
	createdAt: number;
	id: string;
	isRead: boolean;
	text: string;
	title: string;
	handleRemoveNotification: (id: string) => void;
	handleLinkClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

const NotificationItem = ({
	createdAt,
	handleRemoveNotification,
	handleLinkClick,
	id,
	isRead,
	text,
	title,
}: INotificationItemProps) => {
	const timeAgo = `${formatDistanceToNowStrict(createdAt)} ago`;
	const notificationClasses = cn(styles.notificationItemContainer, {
		[styles.unread]: !isRead,
	});

	const onClickRemoveNotification = () => handleRemoveNotification(id);

	return (
		<div
			className={notificationClasses}
			data-testid='notification-item'
		>
			<div className={styles.title}>
				<AdaptiveSingleLineText
					className={styles.textTitle}
					maxWidth={280}
					paddingsSize={0}
					text={title}
				/>
				<div
					className={styles.remove}
					onClick={onClickRemoveNotification}
				>
					{Icons.removeIcon()}
				</div>
			</div>
			<div className={styles?.message}>
				<div
					dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text.replace(/\n/g, '<br />')) }}
					className={styles.text}
					data-testid='notification-text'
					onClick={handleLinkClick}
				/>
				<div
					className={styles.time}
					data-testid='notification-time-ago'
				>
					{timeAgo}
				</div>
			</div>
		</div>
	);
};

export default NotificationItem;
